import cx from 'classnames';
import React from 'react';
import styled from 'styled-components';

import ChevronLeft from 'components/Icons/ChevronLeft';
import ExternalLink from 'components/Icons/ExternalLink';
import colors from 'utils/colors';

import { LinkProps } from './interfaces';

const StyledLink = styled.a`
  letter-spacing: -0.3px;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: ${colors.brown};
  text-decoration: underline;

  > svg {
    height: 1em;
  }

  > svg.chevronBack {
    position: relative;
    top: 0.16em;
    margin-right: 0.4em;

    > g > path {
      fill: ${colors.brown};
    }
  }

  > svg.externalLink {
    margin-left: 0.2em;
    height: 0.8em;

  }

  :hover,
  :active,
  :focus {
    cursor: pointer;
    color: ${colors.teal};

    > svg.chevronBack > g > path {
      fill: ${colors.teal};
    }

    > svg > g > g {
      fill: ${colors.teal};
    }
  }
`;

export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(function Link(
  {
    value,
    href = '#',
    showExtraLink = false,
    showBackChevron = false,
    children,
    extraLinkProps,
    chevronProps,
    target = '_blank',
    ...props
  },
  ref
) {
  return (
    <StyledLink
      href={href}
      {...props}
      target={target}
      ref={ref}
      // See https://medium.com/sedeo/how-to-fix-target-blank-a-security-and-performance-issue-in-web-pages-2118eba1ce2f
      {...(target === '_blank' ? { rel: 'noopener noreferrer' } : {})}>
      {showBackChevron && (
        <ChevronLeft {...chevronProps} className={cx('chevronBack', chevronProps?.className)} />
      )}
      {children || value}
      {showExtraLink && (
        <ExternalLink
          {...extraLinkProps}
          className={cx('externalLink', extraLinkProps?.className)}
        />
      )}
    </StyledLink>
  );
});

export default Link;
